import catalogModule from '../catalogModule';

function genreFiltersController($log, $scope) {
  'ngInject';

  $scope.clearGenreFilters = () => {
    $scope.navigationMenu.genres.forEach(genre => {
      genre.isSelected = false;
    });

    $scope.applySearch(true);
  };
}

catalogModule.controller('genreFiltersController', genreFiltersController);

export default genreFiltersController;
